module.exports = __webpack_public_path__ + "static/img/trashicon.7923a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trashicon.png
// module id = AlBF
// module chunks = 1